// Pure, dependency-free predicates for the plan / upgrade-prompt gate.
// Kept out of useAuth.js so they can be unit-tested (useAuth.js is not
// Jest-renderable here — same reasoning as src/utils/loginVerify.js).

import { validate as isValidUUID } from "uuid";

/**
 * A Lucas admin (super-administrator / impersonation) session is identified by
 * a user id that is NOT a UUID — ordinary tenant users always have UUID ids.
 *
 * Fails closed: a missing user, a missing id, or a non-string id is treated as
 * an ordinary tenant session, never as an admin.
 */
export function isAdminSession(user) {
  const id = user?.id;
  if (typeof id !== "string" || id === "") return false;
  return !isValidUUID(id);
}
